module.exports = __webpack_public_path__ + "img/close.5a2b243e.svg";